module.exports = __webpack_public_path__ + "static/media/background-aluminum.fa44f90d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background-aluminum.jpg
// module id = 1016
// module chunks = 0